
import { defineComponent } from 'vue'
import { shortenLargeNumber } from '~/utils/string'

// Modal to confirm manual syncing
export default defineComponent({
  name: 'ConfirmSyncModal',
  props: {
    providerName: {
      type: String,
      required: true
    },
    teamMemberRoleUpdatedCount: {
      type: Number,
      default: 0
    },
    repoCollaboratorUpdatedCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      overrideChanges: true
    }
  },
  methods: {
    emitSyncAccessSettings(close: () => void): void {
      this.$emit('sync-access-settings', this.overrideChanges)
      close()
    }
  },
  computed: {
    teamMemberRoleUpdatedCopyText(): string {
      if (this.teamMemberRoleUpdatedCount === 1) {
        return 'Role of 1 user has been manually updated on DeepSource. This will be affected by the sync.'
      }

      return `Roles of ${shortenLargeNumber(
        this.teamMemberRoleUpdatedCount
      )} users are manually updated on DeepSource. This will be affected by the sync.`
    },
    repoCollaboratorUpdatedCopyText(): string {
      if (this.repoCollaboratorUpdatedCount === 1) {
        return 'Repository permissions for 1 user has been manually updated on DeepSource. This will be affected by the sync.'
      }

      return `Repository permissions for ${shortenLargeNumber(
        this.repoCollaboratorUpdatedCount
      )} users are manually updated on DeepSource. This will be affected by the sync.`
    }
  }
})
